/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>民宿活动列表</public-title>
    <div class="load-area">
      <gcon-search @getSearchCon="getSearchCon" />
      <p v-if="StoreLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col">{{Itemize.title}}</li>
          <li class="w-50 list-item-col">{{Itemize.onsale_nums}}</li>
          <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
            {{Itemize.verify | formatVar('verifyType')}}
          </li>
          <li class="w-50 list-item-col">
            {{Itemize.province_name}}-{{Itemize.city_name}}-{{Itemize.district_name}}
          </li>
          <li class="w-50 list-item-col-end">
            <span class="text-link" @click="goForDetail(Itemize)">查看</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="StoreLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapState, mapActions } from 'vuex'
  import GconSearch from '../GconSearch'

  export default {
    name: 'GroupDiscountList',
    components: { GconSearch },
    computed: {
      ...mapState(['StoreLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query }
    },
    watch:{
      queryCon() { this.groupGetStoreLists({ page:this.queryCon.page, type:5, ...this.info })  },
    },
    data() {
      return {
        titleArr:['门店名称','民宿活动','门店认证','所在地','操作'],
        info: {}
      }
    },
    created() {
      if (this.queryCon.hasOwnProperty('page')) this.groupGetStoreLists({ page:this.queryCon.page, type:5 })
      else this.groupGetStoreLists({ page:1, type:5 })
    },
    methods:{
      ...mapActions(['groupGetStoreLists']),
      //门店去认证
      goVerify(item) {
        this.$router.push({name:'GroupAddStore',query:{step:1,store:item.store_id}})
      },
      //查看门店活动
      goForDetail(item) {
        this.$router.push({name:this.$route.name,query:{...this.$route.query,store:item.store_id,GST:item.title}})
      },
      getSearchCon (info) {
        this.info=info;
        this.groupGetStoreLists({ page:1, type:5, ...info })
      }
    }
  }
</script>
